import React from 'react';
import { connect } from 'react-redux';
import Gallery from '../../Gallery/Gallery';
import { getAllImages } from '../../../../redux/gallery/gallerySelector';

const GalleryWrapper = ({ handleClick, images }) => {
  const mediaBaseURL = process.env.REACT_APP_MEDIA_BASE_URL;

  const handleImageClick = (imageId) => {
    // Find the image data by ID
    const selectedImage = images.images.results?.find(img => img.id === imageId);
    if (selectedImage && handleClick) {
      let imageUrl = selectedImage.media_url;
      const imageTitle = selectedImage.title;
      
      // Extract only the relative path from the full URL
      if (imageUrl.startsWith('http')) {
        // If it's a full URL, extract the path part
        try {
          const url = new URL(imageUrl);
          imageUrl = url.pathname;
        } catch (e) {
          // If URL parsing fails, try to extract path manually
          const pathMatch = imageUrl.match(/\/media\/.*$/);
          if (pathMatch) {
            imageUrl = pathMatch[0];
          }
        }
      }
      
      handleClick(imageId, imageUrl, imageTitle);
    }
  };

  return (
    <div>
      <h3 style={{ marginBottom: '20px', textAlign: 'center' }}>Select Image from Gallery</h3>
      <Gallery handleClick={handleImageClick} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    images: getAllImages(state),
  };
};

export default connect(mapStateToProps)(GalleryWrapper);